import { render, staticRenderFns } from "./paymentInfo.vue?vue&type=template&id=704b0ac6&scoped=true"
import script from "./paymentInfo.vue?vue&type=script&lang=js"
export * from "./paymentInfo.vue?vue&type=script&lang=js"
import style0 from "./paymentInfo.vue?vue&type=style&index=0&id=704b0ac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704b0ac6",
  null
  
)

export default component.exports